class ScrollViewComponentData {
	constructor() {
		this.enabled = true;
	}
}

export { ScrollViewComponentData };
